import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
const colors = new Colors();

const TokenIcon = ({seedHash, className="token-icon"}) => { 
    let style = {};
    if (seedHash) {
        let color = colors.saturate(colors.getColorForHash(seedHash), 1);
        let _colors = [color, colors.compliment(color, 1.1), colors.compliment(color, 1.2), colors.compliment(color, 1.3), colors.compliment(color, 1.4), colors.compliment(color, 1.5)];
        style = {
            background: `radial-gradient(92% 75.29% at 2.96% 24.36%, ${_colors[0]} 0.52%, ${_colors[1]} 18.75%, ${_colors[2]} 34.38%, ${_colors[3]} 49.48%, ${_colors[4]} 74.48%, ${_colors[5]} 100%)`
        };
    }

    return (
        <div style={style} className={className}>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenIcon);
